<script setup lang="ts">
import EntityPreviewTooltip from "~/components/dumb/EntityPreviewTooltip.vue";
import type { Doc, Task } from "~/shared/types";

import EntityDropdownItem from "./EntityDropdownItem.vue";

defineProps<{
  task?: Task;
  doc?: Doc;
  label: string;
  selected: boolean;
  disabled: boolean;
  lineThrough: boolean;
  showOpen?: boolean;
}>();

const emit = defineEmits<{
  open: [];
  remove: [];
}>();
</script>

<template>
  <EntityPreviewTooltip :task-duid="task?.duid" :doc-duid="doc?.duid" :distance="4" block>
    <EntityDropdownItem
      :label="label"
      :selected="selected"
      :disabled="disabled"
      :line-through="lineThrough"
      :show-open="showOpen"
      @open="emit('open')"
      @remove="emit('remove')" />
  </EntityPreviewTooltip>
</template>
